import Vue from 'vue'
import Router from 'vue-router'
import Store from './store'
import * as menus from './routers'
import * as types from './store/mutation-types'

Vue.use(Router)

function generateRoutesFromMenu(menu = [], routes = []) {
  // console.log(menu)
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (item.children) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}
// console.log('menus:', menus)
const routers = new Router({
  mode: 'history',
  // scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...generateRoutesFromMenu(menus.default)
    // {path: '*', redirect: {name: getDefaultRoute(menu).name}}
  ],
  // scrollBehavior(to, from, savedPosition) {
  // console.log(to, from, savedPosition)
  // },
  base: process.env.BASE_URL || 'localhost'
  // routes: [
  //   {
  //     path: '/',
  //     name: 'home',
  //     component: Home
  //   },
  //   {
  //     path: '/about',
  //     name: 'about',
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     component: () =>
  //       import(/* webpackChunkName: "about" */ './views/About.vue')
  //   }
  // ]
})

routers.beforeEach((to, from, next) => {
  document.title = to.meta.title
  if (Store.state.ModalComponent.show) {
    Store.dispatch(types.SET_MODAL_COMPONENT, { component: '', active: false })
  }

  // Check if you are logged in.
  Store.dispatch(types.CHECK_LOGIN).then(e => {
    console.log('CHECK_LOGIN:', e)
  })

  if (
    to.path === '/' ||
    to.path === '/login' ||
    to.path === '/signup' ||
    (to.path === '/main' && Store.getters.userInfo.type != 'photographer')
  ) {
    next()
  } else {
    Store.dispatch(types.CHECK_LOGIN)
      .then(e => {
        console.log(
          'CHECK_LOGIN:',
          Store.getters.userInfo.status,
          Store.getters.userInfo.type === to.meta.loginType,
          e
        )
        if (
          Store.getters.userInfo.status &&
          Store.getters.userInfo.type === to.meta.loginType &&
          e
        ) {
          console.log('Login success')
          // Go ahead with your want page.
          next()
        } else {
          if (Store.getters.userInfo.type === 'photographer') {
            if (to.path === '/main') {
              // alert('You can not access. If you want to access main page. you have to change. Account id.')
              next({ path: '/photographer/request' })
            } else {
              next()
            }
          } else {
            console.log('Login fails. You ahead to go that where you want.')
            // You need a login token.
            alert('YOU NEED TO A LOGIN')
            // User has not the login session.
            Store.dispatch(types.SET_MODAL_COMPONENT, {
              component: 'login',
              active: true,
              type: 'full'
            }).then(() => {
              next({ path: '/main' })
            })
          }
        }
      })
      .catch(e => {
        console.error('현재 로그인 상태가 아니에요. 당신의 데이터 :', e)
        // You can approach in path main, landing pages.
        if (to.path === '/main') {
          next()
        } else {
          alert('You need to a login')
          next({ path: '/' })
        }
      })
  }
})

// router.afterEach((to, from) => {
//   // store.commit('setLoading', false)
// })

export default routers
